import find from 'lodash-es/find';
import React from 'react';
import { StringParam, useQueryParam } from 'use-query-params';
import { ConcealedText, ContributionSideSummaryHeader, SideSummary, useDashboardPermissions, } from '@components';
import { ButtonClean, useModalContext } from '@fourthwall/components';
import { getCountryNameByCode } from '@fourthwall/utils/dist/inputs';
import * as S from '../../Order.styled';
import { OrderEmailModal } from '../../modules/OrderEmailModal';
import { OrderShippingAddressModal } from '../../modules/OrderShippingAddressModal';
import { SupporterPhoneModal } from '../../modules/SupporterPhoneModal';
import { getFullName } from '../../utils/getFullName';
export const OrderSideSummary = ({ order }) => {
    const { open } = useModalContext();
    const { hasPermission } = useDashboardPermissions();
    const [isAddressModalOpen, setIsAddressModalOpen] = useQueryParam('editAddress', StringParam);
    const fullName = getFullName(order?.shipping.address?.firstName, order?.shipping.address?.lastName);
    const renderSupporterContact = () => {
        if (order?.salesChannel?.type === 'TikTok') {
            return (React.createElement(SideSummary.Item, { title: "Supporter contact" },
                React.createElement(S.Email, null, "N/A (Purchased from TikTok)")));
        }
        return (React.createElement(SideSummary.Item, { title: "Supporter contact" },
            React.createElement(S.Email, { title: order?.email }, order?.email),
            hasPermission('contributions.orders.edit') && order?.email && (React.createElement(ButtonClean, { label: "Edit", onClick: () => {
                    open(OrderEmailModal, { orderId: order.id, initialValues: { email: order.email } });
                } })),
            order?.supporterPhoneNumber && (React.createElement(React.Fragment, null,
                React.createElement(S.Phone, { title: order?.supporterPhoneNumber }, order?.supporterPhoneNumber),
                hasPermission('contributions.orders.edit') && (React.createElement(ButtonClean, { label: "Edit", onClick: () => {
                        open(SupporterPhoneModal, {
                            orderId: order.id,
                            initialValues: { phoneNumber: order.supporterPhoneNumber || '' },
                        });
                    } }))))));
    };
    const renderAdditionalField = (name, label) => {
        const additionalField = find(order?.additionalFields, { name });
        if (additionalField) {
            return React.createElement(SideSummary.Item, { title: label || name }, additionalField.value);
        }
        return null;
    };
    return (React.createElement(SideSummary, null,
        isAddressModalOpen && React.createElement(OrderShippingAddressModal, { close: () => setIsAddressModalOpen('') }),
        fullName && (React.createElement(SideSummary.Item, null,
            React.createElement(ContributionSideSummaryHeader, { name: fullName }))),
        order?.shipping.address && (React.createElement(SideSummary.Item, { title: "Shipping address" },
            React.createElement(ConcealedText, { showLabel: "View shipping address", hideLabel: "Hide shipping address" }, order?.shipping.address && (React.createElement(React.Fragment, null,
                React.createElement("p", null, fullName),
                order?.shipping.address.phone && React.createElement("p", null, order?.shipping.address.phone),
                React.createElement("p", null, order?.shipping.address.address1),
                React.createElement("p", null, order?.shipping.address.address2),
                React.createElement("p", null, `${order?.shipping.address.city} ${order?.shipping.address.state}${order?.shipping.address.zip ? ` ${order?.shipping.address.zip}` : ''}`),
                React.createElement("p", null, getCountryNameByCode(order?.shipping.address.country))))),
            order?.status !== 'COMPLETED' &&
                order?.status !== 'CANCELLED' &&
                hasPermission('contributions.orders.edit') && (React.createElement(ButtonClean, { label: "Edit shipping address", onClick: () => setIsAddressModalOpen('true') })))),
        renderSupporterContact(),
        renderAdditionalField('employer'),
        renderAdditionalField('occupation'),
        renderAdditionalField('username'),
        renderAdditionalField('messageSelectedOption', 'Message choice')));
};
